import { Phone, MessageCircle } from "lucide-react";

const FloatingButtons = () => {
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      "Hola, me gustaría reservar mesa en Abacería Como en Casa."
    );
    window.open(`https://wa.me/34672729957?text=${message}`, "_blank");
  };

  const scrollToReservation = () => {
    const element = document.querySelector("#reservas");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsApp}
        data-testid="floating-whatsapp"
        className="floating-btn bottom-8 right-8 w-14 h-14 bg-[#25D366] text-white flex items-center justify-center"
        aria-label="Contactar por WhatsApp"
      >
        <MessageCircle size={24} />
      </button>

      {/* Reserve Button */}
      <button
        onClick={scrollToReservation}
        data-testid="floating-reserve"
        className="floating-btn bottom-8 right-24 w-14 h-14 bg-[#800020] text-white flex items-center justify-center pulse-animation"
        aria-label="Reservar mesa"
      >
        <Phone size={24} />
      </button>

      {/* Desktop expanded reserve button */}
      <button
        onClick={scrollToReservation}
        data-testid="floating-reserve-desktop"
        className="hidden lg:flex floating-btn bottom-8 left-8 bg-[#800020] text-white items-center gap-3 px-6 py-4"
      >
        <Phone size={18} />
        <span className="font-body text-sm uppercase tracking-widest">
          Reservar Mesa
        </span>
      </button>
    </>
  );
};

export default FloatingButtons;
